var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BSpinner } from 'bootstrap-vue';
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Avatar.prototype, "customStyle", {
        get: function () {
            var styles = {};
            if (this.width) {
                styles.width = this.width + "px";
            }
            if (this.height) {
                styles.height = this.height + "px";
            }
            return styles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Avatar.prototype, "customClasses", {
        get: function () {
            var classes = ["avatar--" + this.size];
            if (!this.picture) {
                if (this.inversePlaceholder) {
                    classes.push.apply(classes, ['bg-gray-200', 'text-primary']);
                }
                else {
                    classes.push.apply(classes, ['bg-primary', 'text-white']);
                }
            }
            return classes;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], Avatar.prototype, "inversePlaceholder", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], Avatar.prototype, "picture", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], Avatar.prototype, "pictureClass", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], Avatar.prototype, "initials", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], Avatar.prototype, "name", void 0);
    __decorate([
        Prop({
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], Avatar.prototype, "loading", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], Avatar.prototype, "width", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], Avatar.prototype, "height", void 0);
    __decorate([
        Prop({
            default: 'md',
        }),
        __metadata("design:type", String)
    ], Avatar.prototype, "size", void 0);
    Avatar = __decorate([
        Component({
            components: {
                BSpinner: BSpinner,
            },
        })
    ], Avatar);
    return Avatar;
}(Vue));
export default Avatar;
